<template>
    <div class="game-info-main common-layout-index">
        <!--            面板打开时-->
        <div class="game-info" v-if="panelStatus">
            <div class="game-info-mask" @click="setPanel(false)"></div>
            <div class="game-info-box">
                <div class="game-item">
                    <div class="user-logo"></div>
                    <div class="current-info">
                        <div class="current-account">当前账号：{{ account }}</div>
                        <div class="current-time">
                            剩余时长：{{ secondsToTime(limitTime, 'time') }}
                        </div>
                    </div>
                    <div class="get-more-time" @click="buyTime">
                        <div v-if="missionCompleteStatus" class="has-red-point"></div>
                    </div>
                </div>
                <div class="game-line"></div>
                <div class="game-item">
                    <div class="wifi-status status-item">
                        <div>网络状态</div>
                        <div>
                            <el-switch
                                @change="changeFPS"
                                v-model="showFps"
                                active-color="#C1372C"
                                inactive-color="#b4aaa9">
                            </el-switch>
                        </div>
                    </div>
                    <div class="full-page-status status-item">
                        <div>全屏模式</div>
                        <div>
                            <el-switch
                                @change="changeFull"
                                v-model="showFull"
                                active-color="#C1372C"
                                inactive-color="#b4aaa9">
                            </el-switch>
                        </div>
                    </div>
                </div>
                <div class="game-line"></div>
                <div class="game-item flex-full">
                    <div>
                        <div class="status-item game-share-icon">
                            <div>分享好友</div>
                            <div @click="share" class="game-icon"></div>
                        </div>

                        <div class="status-item game-kf-icon">
                            <div>联系客服</div>
                            <div class="game-icon" @click="kf"></div>
                        </div>
                        <!-- <div class="kf-tips" @click="copy">*点击此处复制相关信息，便于我们排查问题</div> -->
                    </div>
                    <div class="close-game">
                        <div class="close-game-tips"><span></span>点击游戏画面即可关闭菜单</div>
                        <div class="close-game-btn" @click="exitGame"><span></span>退出游戏</div>
                    </div>
                </div>
            </div>
        </div>
        <!--            面板关闭悬浮按钮-->
        <div v-else class="close-panel">
            <div class="save-btn" @click="submitSave" v-if="supportInstall && !is4399"></div>
            <div class="time-btn" @click="setPanel(true)">
                <div>
                    <div class="time-btn-text">剩余时长</div>
                    <div class="time-btn-value">{{ secondsToTime(limitTime, 'time') }}</div>
                </div>
                <div class="open-menus">
                    <div class="open-menus-btn">打开菜单</div>
                </div>
            </div>
        </div>
        <!--        具名插槽，描述logo和登录方式之间的内容-->
        <div class="common-login-center" v-show="showFps">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { secondsToTime } from '@/utils/util'
import { qiyuInit } from '@/utils/qiyu'
let timer1 = null;
export default {
    computed: {
        ...mapGetters(['panelStatus', 'missionCompleteStatus', 'is4399'])
    },
    props: {
        limitTime: {
            type: Number,
            default: 0
        },
        token: {
            type: String,
            default: ''
        },
        share_link: {
            type: String,
            default: ''
        },
        supportInstall: {
            type: Boolean,
            default: false
        },
        wdId: {
            type: Number,
            default: 0
        },
        account: {
            required: true,
            type: String,
        },
    },
    components: {
    },
    data () {
        return {
            secondsToTime,
            showFps: false,
            showFull: false,
            btns: [
                {
                    id: '1',
                    icon: 'buyTime',
                    name: '购买时长',
                    func: 'buyTime'
                },
                {
                    id: '2',
                    icon: 'download',
                    name: '游戏下载',
                    func: 'download'
                },
                {
                    id: '5',
                    icon: 'wifi',
                    name: '网络状态',
                    func: 'wifi'
                },
                {
                    id: '6',
                    icon: 'fullPage',
                    name: '全屏模式',
                    func: 'fullPage'
                },
                {
                    id: '7',
                    icon: 'kf',
                    name: '联系客服',
                    func: 'kf'
                },
                {
                    id: '8',
                    icon: 'exitGame',
                    name: '退出游戏',
                    func: 'exitGame'
                },
                {
                    id: '9',
                    icon: 'copy',
                    name: '复制',
                    func: 'copy'
                },
            ]
        }
    },

    mounted () {
        this.setPanelStatus(true);
        timer1 = setTimeout(() => {
            this.setPanelStatus(false)
            clearTimeout(timer1)
            timer1 = null;
        }, 2000)
        console.log(this.supportInstall, '---this.supportInstall---')
        const _this = this;
        // const $fullscreen = document.querySelector('.fullPage');
        document.addEventListener("fullscreenchange", function () {
            console.log(document.fullscreen, '--document.fullscreen--');
            _this.showFull = document.fullscreen;
        }, false);
        document.addEventListener("mozfullscreenchange", function () {
            console.log(document.mozFullScreen, '--document.mozFullScreen--');
            _this.showFull = document.fullscreen;
        }, false);

        document.addEventListener("webkitfullscreenchange", function () {
            console.log(document.webkitIsFullScreen, '--document.webkitIsFullScreen--');
            _this.showFull = document.fullscreen;
        }, false);

        document.addEventListener("msfullscreenchange", function () {
            console.log(document.msFullscreenElement, '--document.msFullscreenElement--');
            _this.showFull = document.fullscreen;
        }, false);
    },
    methods: {
        ...mapMutations(['setPanelStatus', 'setShowLogin']),
        clickItem (event) {
            this[event]()
        },
        fullPage () {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                document.documentElement.requestFullscreen();
            }
        },
        wifi () {
            this.showFps = !this.showFps
        },
        kf () {
            if (this.is4399) {
                window.open('https://u.4399.com/kf/im/yxssjj2', "_blank")
                return;
            }
            let content = 'https://h5.ssjj.cn/common/clientLink?k=5b13917a6a84ef7a95186847ffb19eb4&wp=1&robotShuntSwitch=1&robotId=5343340&gid=482695878&language=zh-cn';
            const {
                wdId, account
            } = this;
            const hasQuery = content.includes('?');
            const joinPart = hasQuery ? '&' : '?';
            const uidPart = `${wdId !== '' ? joinPart + 'u=' + wdId : ''}`;
            const accountPart = `${account !== '' ? '&t=' + encodeURIComponent(account) : ''}`;
            const constPart = '&qtype=4493270&templateId=';
            const url = `${content + uidPart + accountPart + constPart}`;
            const open = () => window.open(url);
            const data = [
                {
                    key: 'game',
                    label: '游戏',
                    value: '云·生死狙击2',
                    index: 0,
                },
                {
                    key: 'sub_channel_id',
                    label: '渠道id',
                    value: '1',
                    index: 1,
                },
                {
                    key: 'channel_id',
                    label: '子渠道id',
                    value: '4261',
                    index: 2,
                },
            ];
            if (wdId) {
                data.push({
                    key: 'wd_id',
                    label: '无端id',
                    value: wdId,
                    index: 3,
                });
            }
            const config = {
                data: JSON.stringify(data),
            };
            if (wdId) {
                config.uid = wdId;
            }
            if (account) {
                config.name = account;
            }
            qiyuInit(config).then(open);
        },
        exitGame () {
            console.log('exitGame')
            this.$emit('exitGame')
        },
        buyTime () {
            console.log('buyTime')
            this.$emit('buyTime')
        },
        copy () {
            this.$emit('copy')
        },
        share () {
            this.$copyText(this.share_link).then((e) => {
                this.$message.success('复制成功！快去分享给你的好友吧！');
                console.log(e)
            }, (e) => {
                this.$message.error('复制失败');
                console.log(e)
            });
        },
        submitSave () {
            this.$parent.setYunLog(1)
            this.$emit('submitSave')
        },
        setPanel (value) {
            this.setPanelStatus(value)
        },
        changeFPS (val) {
            this.showFps = val;
        },
        changeFull (val) {
            this.fullPage();
        },
    }
}
</script>
<style scoped lang="less">
.common-layout-index {
    display: flex;
    align-items: flex-start;
    //padding: 20px;
    position: relative;
    box-sizing: border-box;
    justify-content: space-between;

    .close-panel {
        display: flex;
        z-index: 199;
        position: fixed;
        top: 120px;
        left: 0;
        cursor: pointer;
        opacity: .3;
        .save-btn {
            width: 68px;
            height: 92px;
            background-image: url('@/assets/images/gameInfo/save-btn.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
        .time-btn {
            width: 160px;
            height: 92px;
            background-image: url('@/assets/images/gameInfo/duration-btn.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .time-btn-text {
            font-size: 20px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            color: #FFFFFF;
        }
        .time-btn-value {
            font-size: 18px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }
        .open-menus {
            display: none;
            //display: flex;
            position: absolute;
            background-image: url('@/assets/images/gameInfo/duration-btn.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 100%;
            height: 100%;
            z-index: 10;
            justify-content: center;
            align-items: center;
            opacity: 1;
            font-size: 24px;
            color: #fff;
        }
        //.open-menus-btn {
        //
        //}
        &:hover {
            opacity: 1;
        }
        &:hover .open-menus {
            display: flex;
        }
    }

    .hide-panel {
        width: 60px;
        height: 60px;
        background-image: url('@/assets/images/gameInfo/hide-panel.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: absolute;
        top: 98px;
        right: -30px;
        transform: translateY(-50%);
        cursor: pointer;
    }

    .game-info {
        position: fixed;
        height: 100%;
        width: 100%;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        min-width: 1px;
        min-height: 1px;
        display: block;
        z-index: 199;
    }

    //.test {
    //    animation: tranx 6s linear 1s infinite;
    //}
    .game-info-mask {
        height: 100%;
        width: 100%;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: block;
        background: rgba(0, 0, 0, .5);
    }
    .game-info-box {
        background-image: url('@/assets/images/gameInfo/game-info-box.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: fixed;
        top: 0;
        z-index: 201;
        left: 0;
        width: 400px;
        height: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;

        .game-item {
            padding: 30px 0;
            width: 100%;
        }
        .flex-full {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .close-game {
            .close-game-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-size: 26px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                margin-bottom: 20px;
                span {
                    display: inline-block;
                    width: 20px;
                    height: 22px;
                    background-image: url("../assets/images/gameInfo/close-game.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
            .close-game-tips {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                font-size: 14px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                span {
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    background-image: url("../assets/images/gameInfo/tips.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                }
            }
        }
        .game-line {
            width: 100%;
            height: 1px;
            background: #FFFFFF;
            opacity: 1;
        }

        .current-info {
            .current-account {
                font-size: 18px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                margin-top: 50px;
            }
            .current-time {
                font-size: 18px;
                font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                margin: 50px 0;
            }
        }
        .get-more-time {
            width: 196px;
            height: 58px;
            cursor: pointer;
            margin: 0 auto;
            background-image: url("../assets/images/gameInfo/get-more-time.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            position: relative;
            .has-red-point {
                position: absolute;
                width: 14px;
                height: 14px;
                opacity: 1;
                border: 1px solid #FFFFFF;
                border-radius: 50%;
                background: #BB2232;
                right: -7px;
                top: -7px;
            }
        }
        .status-item {
            display: flex;
            font-size: 20px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px;
        }
        .game-icon {
            width: 24px;
            height: 24px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            cursor: pointer;
        }
        .game-share-icon {
            margin-bottom: 50px;
            .game-icon {
                background-image: url("../assets/images/gameInfo/game-share-icon.png");
            }
        }
        .game-kf-icon {
            .game-icon {
                background-image: url("../assets/images/gameInfo/game-kf-icon.png");
            }
        }
        .kf-tips {
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            text-decoration: underline;
            margin-top: 10px;
            cursor: pointer;
        }
        .wifi-status {
            margin-bottom: 50px;
        }
        .user-logo {
            width: 146px;
            height: 146px;
            border-radius: 50%;
            opacity: 1;
            background-image: url("../assets/images/home/user-logo.png");
            background-size: 100% 100%;
            margin: 0 auto;
            background-repeat: no-repeat;
        }
    }
}

a {
    text-decoration: none;
}

.common-login-center {
    //flex: 1;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 199;
}

.loginCon {
    width: auto;
    padding-top: 4px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.common-login {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    top: 50px;
    right: 0;
    z-index: 199;
}

.f-cb {
    zoom: 1;
}

.unlogin, .haslogin {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    color: #fff;
    font-size: 18px;
}

.unlogin li,
.haslogin li {
    margin-right: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
}

.unlogin li:hover,
.haslogin li:hover {
  display: none;
}

.quick-login span {
    display: inline-block;
    line-height: 60px;
    height: 60px;
    vertical-align: bottom;
}

@keyframes tranx {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

/*@keyframes btn_hover_light {*/
/*    0% {*/
/*        box-shadow: 0 0 0 #101010;*/
/*    }*/
/*    100% {*/
/*        box-shadow: 0 0 40px #101010;*/
/*    }*/
/*}*/

/*@media screen and (max-width: 1000px) {*/
/*}*/
</style>
